import APIClient from "web_modules/APIClient";
import { ConditionShape } from "@eave/shared/types/api";

export function getConditionsForApplication(appID: number) {
  return APIClient.get(`/conditions/${appID}`);
}

export function getConditionsTemplates(): Promise<any> {
  return APIClient.get(`/uw/condition_templates?format=by_category`);
}

export function getConditionsTemplate(templateType: string): Promise<any> {
  return APIClient.get(`/uw/condition_templates/${templateType}`);
}

export function createConditionToDocumentLink(conditionID: number, documentID: number) {
  return APIClient.post("/uw/link_condition_document", {
    condition_id: conditionID,
    document_id: documentID,
  });
}

export function deleteConditionToDocumentLink(conditionID: number, documentID: number) {
  return APIClient.post("/uw/unlink_condition_document", {
    condition_id: conditionID,
    document_id: documentID,
  });
}

export function createCondition(
  condition,
  owner,
  stage,
  application_id,
  document_type,
  status,
  template_name?,
) {
  return APIClient.post(`/conditions`, {
    condition,
    owner,
    stage,
    application_id,
    document_type,
    status,
    template_name,
  });
}

export function updateCondition(condition) {
  return APIClient.put("/conditions", { condition }) as Promise<{ condition: ConditionShape }>;
}

export function createConditionsPDF(appID: number, values: Record<string, any> = null) {
  const endpoint = `/uw/loan_applications/${appID}/generate_uw_conditional_approval`;
  if (values) {
    return APIClient.post(endpoint, {
      vars: values,
    });
  }
  return APIClient.post(endpoint, {});
}

export function saveConditionsPDF(appID: number, s3_key: string) {
  return APIClient.post(`/uw/loan_applications/${appID}/save_uw_conditional_approval`, { s3_key });
}
